import { publicEnv } from '@/config/runtime'
export const TURNSTILE_SITE_KEY = publicEnv('VUE_APP_TURNSTILE_SITE_KEY') || ''
